<!--Aucune action présélectionnée : l’envoi est irréversible côté fournisseur, il ne doit pas s’obtenir
    par une simple validation (SU #119400).-->
<val-boite-dialogue-generique #boiteDialogue
                              [titre]="titre"
                              class="val-statuts-a-envoyer-factures-achat"
                              [validerDesactive]="actionSelectionnee === null"
                              (validerClick)="Valider ()"
                              (annulerClick)="Annuler ()">
  <div contenu class="val-statuts-a-envoyer-factures-achat-contenu">
    <val-simple-panel>
      <val-controle-conteneur label="Action :"
                              [tailleLabel]="tailleLabels">
        <kendo-combobox class="val-kd-combobox"
                        size="small"
                        [clearButton]="false"
                        [popupSettings]="{appendTo: 'component', popupClass: 'val-kd-combo-popup'}"
                        [data]="actions"
                        textField="libelle"
                        valueField="envoyer"
                        [(value)]="actionSelectionnee">
        </kendo-combobox>
      </val-controle-conteneur>
      <div style="height: 4px;"></div>
      <div class="val-statuts-a-envoyer-factures-achat-selection">
        {{nombreFacturesSelectionnees}} facture(s) sélectionnée(s).
      </div>
      @if (actionSelectionnee?.envoyer)
      {
        <div class="val-statuts-a-envoyer-factures-achat-alerte">
          Un statut transmis part chez le fournisseur et ne se retire pas.
        </div>
      }
    </val-simple-panel>
  </div>
</val-boite-dialogue-generique>
<val-boite-dialogue-messages #boiteDialogueMessages></val-boite-dialogue-messages>
